import React, { FC } from 'react';
import { Form as AntdForm } from 'antd';
import { FormProps, FormItemProps, FormListProps } from 'antd/lib/form';

type Props =
  | ({
      isFormItem?: boolean;
      isListItem?: boolean;
      isReset?: boolean;
    } & FormProps)
  | FormItemProps
  | FormListProps;

export const Form: FC<Props> = (props: any) => {
  const form = AntdForm.useFormInstance();

  if (props.isFormItem) {
    return <AntdForm.Item {...props} form={form} />;
  }

  if (props.isListItem) {
    return <AntdForm.List {...props} form={form} />;
  }

  return (
    <AntdForm {...props} form={form}>
      {props.children as any}
    </AntdForm>
  );
};

export default Form;
